<template>
  <div v-if="shouldShow"
       class="table-responsive">
    <b-button v-b-toggle="id"
              size="sm">
      Detalhes
    </b-button>
    <b-collapse :id="id"
                class="mt-2">
      <table class="table bg-light">
        <tbody>
          <tr v-if="status">
            <th>Status</th>
            <td>{{ status }}</td>
          </tr>
          <tr v-if="name">
            <th>Name</th>
            <td>{{ name }}</td>
          </tr>
          <tr v-if="message">
            <th>Mensagem: </th>
            <td>{{ message }}</td>
          </tr>
        </tbody>
      </table>
    </b-collapse>
  </div>
</template>

<script>
  import uuidv4 from 'uuid/v4'

  export default {
    props: [ 'error' ],
    data () {
      return {
        status: null,
        name: null,
        message: null
      }
    },
    computed: {
      shouldShow () {
        return process.env.NODE_ENV === 'development'
      },

      id () {
        return `server-error-${uuidv4()}`
      }
    },
    mounted () {
      if ('error' in this.error) {
        this.populate(this.error.error)
      } else {
        this.populate(this.error)
      }
    },
    methods: {
      populate ({ message, status, name }) {
        this.message = message
        this.status = status
        this.name = name
      }
    }
  }
</script>
